<template>
  
  <div style="width:770px;marin:0 auto;margin-top:10px;margin-left:10px;">

   
       <el-form ref="userform" :model="userform" label-width="100px" v-loading="loading" :rules="rules">
          <el-form-item :label="$t('newAdd.일괄생성')" class="mb-0 formItem2">
            <div class="d-flex">
             <el-checkbox true-label="1" false-label="0" v-model="pi" style="margin-left: -30px;"></el-checkbox>  
             <div v-if="this.pi==true">
               <el-input v-model="mins" class="mr-1 ml-1" type="number" maxlength="2" style="width: 70px;" placeholder="1"></el-input>  ~  <el-input v-model="maxs"  maxlength="2" class="ml-1  mr-1" type="number" style="width: 70px;" placeholder="30"></el-input> 
                <span class="ml-1 mr-1">번호앞에 0</span><el-select v-model="zerocc" :placeholder="$t('searchText.타이틀선택')" size="mini"  style="width: 120px;">
               <el-option
                      v-for="item in zerocclist"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>   
              </div>  
              </div> 
          </el-form-item>
              <el-radio-group v-model="radio" @change="radioChange">
                 <div class="d-flex">
           
            <el-form-item :label="$t('newAdd.상위선택')" prop="boss" class="mb-0 w-50 formItem2">
               <el-radio class="mr-0 mb-0" label="2" style="margin-left: -30px;margin-top: 2px;">
                  <el-select v-model="userform.boss" :placeholder="$t('searchText.타이틀선택')" size="mini" prop="boss"  :disabled="disabled2"   style="width: 150px;" filterable>
               <el-option
                      v-for="item in splist"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
               </el-radio>
             
            </el-form-item>

            

              </div>
          </el-radio-group>

            <span class="ml-1">카지노롤링:{{ this.boss_event_loing_e }} 슬롯롤링:{{ this.boss_event_loing_slot }}</span>
            
            <table class="table table-bordered myTable">
                <tr>
                  <td width="50%">
                     <el-form-item :label="$t('nav.아이디')" prop="mem_id" class="mb-0 formItem">
                        <el-input v-model="userform.mem_id" class="w-75 mr-1"></el-input>
                        <el-button type="primary" size="mini" plain @click="reConfirm" :loading="reLoading">{{$t('msg.확인')}}</el-button>
                     </el-form-item>
                  </td>
                  <td>
                    <el-form-item :label="$t('tableText.사용자암호')" prop="mem_pw" class="mb-0 formItem">
                    <el-input v-model="userform.mem_pw" class="w-75"></el-input>
                  </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td>
                     <el-form-item  :label="$t('msg.닉네임')"  prop="mem_name" class="mb-0 formItem">
                        <el-input v-model="userform.mem_name" class="w-75"></el-input>
                      </el-form-item>
                  </td>
                  <td>
                    <el-form-item :label="$t('msg.핸드폰')" class="mb-0 formItem" prop="mem_hp">
                            <el-input v-model="userform.mem_hp" class="w-75"></el-input>
                          </el-form-item>
                  </td>
                </tr>
                 <template v-if="(this.sitetype==='1' || this.sitetype==='3' || this.sitetype==='4') && this.power==='1'">
                <tr>
                  <td>
                     <el-form-item :label="$t('msg.파워볼일반')" class="mb-0 formItem" prop="event_loing">
                      <el-input v-model="userform.event_loing" class="w-75"></el-input>
                    </el-form-item>
                  </td>
                  <td>
                     <el-form-item :label="$t('msg.파워볼조합')" class="mb-0 formItem" prop="event_loing_group">
                        <el-input v-model="userform.event_loing_group" class="w-75"></el-input>
                      </el-form-item>
                  </td>
                </tr>
             <!--   <tr>
                  <td>
                     <el-form-item label="사다리 일반" class="mb-0 formItem" prop="event_loing_s">
                        <el-input v-model="userform.event_loing_s" class="w-75"></el-input>
                      </el-form-item>
                  </td>
                  <td>
                      <el-form-item label="사다리 조합" class="mb-0 formItem" prop="event_loing_group_s">
                        <el-input v-model="userform.event_loing_group_s" class="w-75"></el-input>
                      </el-form-item>
                  </td>
                </tr>-->
                 </template>
                   <template v-if="this.bg==='1' ">
                    <tr>
                      <td>
                    <el-form-item :label="$t('msg.보글파일반')" class="mb-0 formItem" prop="event_loing1">
                      <el-input v-model="userform.event_loing1" class="w-75"></el-input>
                    </el-form-item>
                    </td>
                    <td>
                    <el-form-item :label="$t('msg.보글파조합')" class="mb-0 formItem" prop="event_loing_group1">
                      <el-input v-model="userform.event_loing_group1" class="w-75"></el-input>
                    </el-form-item>
                  </td>
                  </tr>
                   <tr>
                      <td>
                    <el-form-item :label="$t('msg.보글사일반')" class="mb-0 formItem" prop="event_loing_s1">
                      <el-input v-model="userform.event_loing_s1" class="w-75"></el-input>
                    </el-form-item>
                  </td>
                  <td>
                    
                    <el-form-item :label="$t('msg.보글사조합')" class="mb-0 formItem" prop="event_loing_group_s1">
                      <el-input v-model="userform.event_loing_group_s1" class="w-75"></el-input>
                    </el-form-item>
                  </td>
                </tr>
                    </template>
                     <template v-if="this.sitetype==='4'">
                      <tr>
                        <td>
                           <el-form-item label="카지노롤링"  class="mb-0 formItem" prop="event_loing_e">
                              <el-input v-model="userform.event_loing_e" class="w-75"></el-input>
                            </el-form-item>
                        </td>
                        <td>
                          <el-form-item :label="$t('msg.슬롯롤링')" class="mb-0 formItem" prop="event_loing_slot">
                              <el-input v-model="userform.event_loing_slot" class="w-75"></el-input>
                            </el-form-item>
                        </td>
                      </tr>
                     
                      
                     
                     </template>
                     <tr>
                       <td>
                           <el-form-item :label="$t('tableText.출금비번')" class="mb-0 formItem" prop="mem_jumin">
                          <el-input v-model="userform.mem_jumin" class="w-75"></el-input>
                        </el-form-item> 
                       </td>
                       <td>
                          <el-form-item :label="$t('tableText.은행명')" class="mb-0 formItem" prop="mem_bankcode">
                            <el-input v-model="userform.mem_bankcode" class="w-75"></el-input>
                          </el-form-item>
                       </td>
                     </tr>
                      <tr>
                       <td>
                         <el-form-item :label="$t('tableText.계좌번호')" class="mb-0 formItem" prop="mem_banknum">
                            <el-input v-model="userform.mem_banknum" class="w-75"></el-input>
                          </el-form-item>
                       </td>
                       <td>
                         <el-form-item :label="$t('msg.예금주')" class="mb-0 formItem" prop="mem_bankname">
                            <el-input v-model="userform.mem_bankname" class="w-75"></el-input>
                          </el-form-item>
                       </td>
                     </tr>
                     

            </table>
 
          </el-form>
         <div class=" d-flex align-items-center">
              <div class="mr-auto">
              <!-- <el-button type="success" @click="shopAdd" size="medium">{{$t('msg.파트너생성')}}</el-button>-->
               
            </div>
             <el-button @click="shopClose" size="medium">{{$t('msg.취소')}}</el-button>
            <el-button type="primary" @click="submitForm" :disabled="disabled" size="medium">{{$t('msg.확인')}}</el-button>
         </div> 
          
  </div>
</template>
<script>
 import shopAdd from './shop-add.vue';
  export default{
     components: {
     
      shopAdd,
    
    },
    props:{
      //接收父组件传来的id值
      info:{
        type:Object,
        default:()=>{
          return {}
        }
      },
       layerid:{
        type:String,
        default:""
      },
      
    },
    computed: {
          
          
            
        },
      data(){
        return{
         boss_event_loing_e:'',
           boss_event_loing_slot:'',
            disabled:false,
         userform:{
            agent_name:'',
            shop_name:'',
             a_code:'',
             c_code:'',
              boss:'',
            mem_pw:'',
            mem_name:'',
            mem_id:'',
             id:'',
            
            event_loing_recom:'0',
            event_loing_recom_s:'0',
            event_loing_group_recom:'0',
            event_loing_group_recom_s:'0',

            event_loing:'0',
            event_loing_group:'0',
            event_loing_s:'0',
            event_loing_group_s:'0',



            event_loing_recom1:'',
            event_loing_recom_s1:'',
            event_loing_group_recom1:'',
            event_loing_group_recom_s1:'',

            event_loing1:'',
            event_loing_group1:'',
            event_loing_s1:'',
            event_loing_group_s1:'',


            event_loing_e:'',
            event_loing_slot:'',
           


              mem_banknum:'',
            mem_bankcode:'',
            mem_bankname:'',
            mem_jumin:'',
            mem_hp:'',
           memlist_id:'',
            status:'',
           
          },
         radio:'2',
         disabled1:true,
         disabled2:false,
         splist:[{
                label:this.$i18n.t("status.선택"),
              value:''
            }
            
            ],
           bonlist:[{
                label:this.$i18n.t("status.선택"),
              value:''
            }
            
            ],

           bubonOptlist:[{
                label:this.$i18n.t("msg.정상"),
                value:'1'
            },
            {
                label:this.$i18n.t("msg.차단"),
                value:'0'
            }
            
            ],
            zerocclist:[
            {
              label: this.$i18n.t("newAdd.없음"),
              value: '0',
            },
             {
              label: '하나',
              value: '1',
            }, {
              label: '두개',
              value: '2',
            }
            ],
          zerocc:'0',
          pi:false,
          editIndex:-1,
          bubontop:false,
          reLoading:false,
           mins:'1',
          maxs:'30',
          back_id:'',
          boss:'',
          tips:'',
          newDate:'',
          v:'',
           domain:window.sessionStorage.getItem('domain'),
           admin_id:window.sessionStorage.getItem('admin_id'),
           power:window.sessionStorage.getItem('power'),
            sitetype:window.sessionStorage.getItem('sitetype'),
            rosing:window.sessionStorage.getItem('rosing'),
            bg:window.sessionStorage.getItem('bg'),
            aid:window.sessionStorage.getItem('admin_id'),
           sim:window.sessionStorage.getItem('sim'),
            loading:false,
             
           rules: {
                  mem_jumin:[{ required: true, message: '', trigger: 'blur'}],
                  
                  event_loing_recom:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_recom_s:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_group_recom:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_group_recom_s:[{ required: true, message: '', trigger: 'blur'}],

                  event_loing:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_s:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_group:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_group_s:[{ required: true, message: '', trigger: 'blur'}],

                  event_loing_e:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_slot:[{ required: true, message: '', trigger: 'blur'}],

                  //agent_name:[{ required: true, message: '', trigger: 'blur'}],
                  mem_bankname:[{ required: true, message: '', trigger: 'blur'}],
                  mem_hp:[{ required: true, message: '', trigger: 'blur'}],
                  mem_bankcode:[{ required: true, message: '', trigger: 'blur'}],
                  mem_banknum:[{ required: true, message: '', trigger: 'blur'}],
                  mem_id:[{ required: true, message: '', trigger: 'blur'}],
                  mem_name:[{ required: true, message: '', trigger: 'blur'}],
                  mem_pw:[{ required: true, message: '', trigger: 'blur'}],
                  //a_code:[{ required: true, message: '', trigger: 'blur'}],
                },
           
           
          
        }
      },
      created() {
         // this.info.id父组件传给子组件的id值
        
         console.log(this.info.id)
         this.fetchManage();
         this.userform.boss = this.info.id
        
          this.boss_event_loing_e = this.formatRate(this.info.event_loing_e)
          this.boss_event_loing_slot = this.formatRate(this.info.event_loing_slot)
          this.userform.event_loing_e = this.boss_event_loing_e
          this.userform.event_loing_slot = this.boss_event_loing_slot
          
             
    },
    
      methods:{
         formatRate(value){
              if(value === '' || value === null || value === undefined) return ''
              const rate = Number(value)
              return Number.isNaN(rate) ? value : String(rate)
         },
         submitForm(){
              let token=window.sessionStorage.getItem('user');
              //a_code c_code 2-1
              if(!this.userform.boss)
              {
                 this.$message({
                    message:'상위선택해주세요',
                    type: 'warning'
                  });
                  return;
              }
              this.$refs.userform.validate((e)=>{
             if(!e) return;

                 this.disabled = true
                 this.loading =true
                 this.$axios({
                        method:'post',
                        url:this.domain+'/user/user_insert',
                        data:{
                        
                          a_code:this.userform.a_code,
                          boss:this.userform.boss,
                          c_code:this.userform.c_code,
                          mem_pw:this.userform.mem_pw,
                          mem_name:this.userform.mem_name,
                          id:this.userform.idx,
                          mem_id:this.userform.mem_id,

                          event_loing:this.userform.event_loing,
                          event_loing_s:this.userform.event_loing_s,
                          event_loing_group:this.userform.event_loing_group,
                          event_loing_group_s:this.userform.event_loing_group_s,

                          event_loing1:this.userform.event_loing1,
                          event_loing_s1:this.userform.event_loing_s1,
                          event_loing_group1:this.userform.event_loing_group1,
                          event_loing_group_s1:this.userform.event_loing_group_s1,


                          event_loing_e:this.userform.event_loing_e,
                          event_loing_slot:this.userform.event_loing_slot,
                       
                          mem_banknum:this.userform.mem_banknum,
                          mem_bankcode:this.userform.mem_bankcode,
                          mem_bankname:this.userform.mem_bankname,
                          mem_jumin:this.userform.mem_jumin,
                          mem_hp:this.userform.mem_hp,
                          pi:this.pi,
                          mins:this.mins,
                          maxs:this.maxs,
                          zerocc:this.zerocc
                          
                         
                        },
                        'Accept': 'application/json',
                         headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                         if(response.data.code !=200)
                            {
                               this.$message({
                                  message:response.data.msg,
                                  type: 'warning'
                                });
                                
                            }else{
                               this.$message({
                                  message:response.data.msg,
                                  type: 'success'
                                });
                               //console.log(this.form);
                               this.$parent.getList();  
                               this.$layer.close(this.layerid)
                         
                              

                            }
                           this.loading =false
                           this.disabled = false
                     
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                       this.loading =false
                           this.disabled = false
                  })
              
            
            })
              
            
        },
       
         shopAdd(){
           
           this.$layer.iframe({
            type: 2,
            title: '파트너추가',
            content: {
                content: shopAdd,
                parent: this,
                data:{
               
                layerid:'id'
                }
              
            },
            shadeClose: false,
             maxmin : true,

            shade: false,
            area: ['800px', '480px'],
           
        });
        
        },
         radioChange(val){
          //console.log('val',val)
          this.disabled2 = (val==='1') ? true : false
          this.disabled1 = (val==='2') ? true : false
        },
         
        reConfirm(){
               let token=window.sessionStorage.getItem('user');

               if(this.userform.mem_id=='')
               {
                    this.$message.error('id error')
                    return;
               }
               this.reLoading = true
               this.$axios({
                    method:'post',
                    url:this.domain+'/user/id_check',
                    data:{
                       mem_id:this.userform.mem_id
                    },
                    'Accept': 'application/json',
                     headers: { 'Authorization': 'Bearer ' + token },
                }).then((response) =>{ 
                   console.log()
                   this.reLoading = false
                   if(response.data.code==200)
                      {
                         this.$message({
                          message:response.data.msg,
                          type: 'success'
                        });

                         
                         
                          
                      }else{
                       this.$message.error(response.data.msg)

                      }

                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
            },
         openShopModel(id){

          if(id=='합계')
          {
             return;
          }

           this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: shopDialog,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            success: function(layero, index) {
              //对加载后的iframe进行宽高度自适应
                //layer.iframeAuto(index);
            },
            shadeClose: false,
             maxmin : true,

            shade: false,
            area: ['1100px','600px'],
           
        });
        
        },

    
        fetchManage(){
        
           let token=window.sessionStorage.getItem('user');
          
          
         

          this.$axios({
                  method:'get',
                  url:this.domain+'/user/zplist_select?type=bossnull&admin=1',
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
              
           let newids=[];

            let obj={};
            //obj.label=this.$i18n.t("msg.본사없음")
            //obj.value=''
            //newids.push(obj); 

           response.data.data.forEach(item=>{
            let obj={};
            obj.label=item.code
            obj.value=item.code
            //newids.push(obj);            
           });

           this.splist=newids

            }).catch((error) =>{
              
            })



             this.form = {
                  recy:'0',

                  agent_name:'',
                  regcode:'',
                  pc_slot:'',
                  pc_e:'',
                  pc_p:'',
                   pc:'',
                  mem_pw:'',
                  mem_name:'',
                  mem_id:'',
                  event_loing_group_recom_s:'0',
                  event_loing_group_recom:'0',
                  event_loing_recom:'0',
                  event_loing_recom_s:'0',

                  event_loing_group_recom_s1:'0',
                  event_loing_group_recom1:'0',
                  event_loing_recom1:'0',
                  event_loing_recom_s1:'0',


                  event_loing_recom_e:'',
                  event_loing_recom_slot:'',
                  mem_banknum:'',
                  mem_bankcode:'',
                  mem_bankname:'',
                  mem_jumin:'',
                  mem_hp:'',
                  status:'1',

                 }



           

            //这里调用select接口

            
             this.editIndex = -1

          
           
          

        },
      
      searchEvent(){
        this.fetchManage()
      },
      shopClose(){
         this.$layer.close(this.layerid);
      },

      }
  }
</script>
<style scoped>

/deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }

 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }
 >>>.el-textarea__inner{
  height:33px;
 }
 >>>.el-form-item__label{
  text-align:left;
 }
</style>



// WEBPACK FOOTER //
// src/components/common/user-add.vue